import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ObservationForm } from "../../components/observation/ObservationForm";
import { getFullName } from "../../helpers/stringHelper";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Observation } from "../../models/observation";
import { observations_apprentice_path, observations_path } from "../../routes";

type ObservationCreateApprenticeProps = {
  observation: Observation;
};

export default function ObservationCreateApprentice({ observation }: ObservationCreateApprenticeProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(observations_path), values);
  return (
    <ContentShell
      title={`Beobachtung: ${getFullName(observation.apprentice)}`}
      onBack={() => router.get(pathWithYearContext(observations_apprentice_path, observation.apprentice.id))}
    >
      <ObservationForm saveButtonLabel="Erstellen" observation={observation} onSubmit={onSubmit} />
    </ContentShell>
  );
}
